<script lang="ts">
  import type { ReadableQuery } from '../api'

  export let query: ReadableQuery<never>
  export let name: string = null
  export let hasError = false

  export let normalize = (data: never): never => data

  let data: never = null
  $: {
    if ($query.loading === false && $query.error === undefined && $query.data !== undefined) {
      data = normalize($query.data)
    }
  }
</script>

{#if $query.loading}
  <p class="container" data-test="loading">Loading {name || ''}...</p>
{:else if $query.error}
  <p class="container" data-test="query-error">{$query.error}</p>
  {#if $query.data}
    <p class="container" data-test="query-error">{JSON.stringify($query.data)}</p>
  {/if}
{:else if hasError && $query.data}
  <p class="container" data-test="query-error">{JSON.stringify($query.data)}</p>
{:else if $query.data}
  <slot {data} />
{/if}
